import { FC } from 'react';

interface AppealTextProps {
  defaultText: string;
}

const AppealText: FC<AppealTextProps> = ({ defaultText }) => {
  return <>{defaultText}</>;
};

export default AppealText;
